var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Heading, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, AlertDialogCloseButton, Spacer, Flex, Stack, ToastErrorBox, useToast, } from 'shared/components';
import { Close } from 'shared/assets/icons';
import { FormProvider, useForm } from 'react-hook-form';
import { IssueReason } from './issueReason';
import { IssueActions } from './issueActions';
import { IssueWarning } from './issueWarning';
import { IssueCaution } from './issueCaution';
import { useHideAppointment } from '../../hooks';
import { useNoteIssueContext } from '../../contexts';
import { useParams } from 'react-router-dom';
export var IssueModal = function (_a) {
    var disclosure = _a.disclosure;
    var id = useParams().id;
    var cancelRef = useRef(null);
    var activeAppointment = useNoteIssueContext().activeAppointment;
    var form = useForm();
    var toast = useToast();
    var _b = useHideAppointment({
        memberId: id !== null && id !== void 0 ? id : '',
        onSuccess: function () { return disclosure.onClose(); },
        onError: function (error) {
            var _a, _b;
            var message = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
            toast({
                status: 'error',
                duration: 15000,
                position: 'top',
                render: function (_a) {
                    var onClose = _a.onClose;
                    return (_jsx(ToastErrorBox, { onClose: onClose, title: "Failed to delete note:", message: message }));
                },
            });
        },
    }), isLoading = _b.isLoading, mutate = _b.mutate;
    var submit = function () {
        var _a = form.getValues(), issueDetails = _a.issueDetails, issueReason = _a.issueReason;
        if (issueReason && issueDetails && activeAppointment) {
            mutate({
                appointment: activeAppointment,
                reason: issueReason,
                details: issueDetails,
            });
        }
    };
    useEffect(function () {
        if (disclosure.isOpen) {
            form.reset();
        }
    }, [disclosure.isOpen]);
    return (_jsx(FormProvider, __assign({}, form, { children: _jsx(AlertDialog, __assign({ size: "2xl", isOpen: disclosure.isOpen, leastDestructiveRef: cancelRef || null, onClose: disclosure.onClose }, { children: _jsx(AlertDialogOverlay, { children: _jsx(AlertDialogContent, { children: _jsxs("form", __assign({ onSubmit: form.handleSubmit(submit), noValidate: true }, { children: [_jsx(AlertDialogHeader, __assign({ px: 5 }, { children: _jsxs(Flex, __assign({ align: "center" }, { children: [_jsx(Heading, __assign({ "data-testid": "issueNotesheader", size: "h2" }, { children: "What is the issue with this note?" })), _jsx(Spacer, {}), _jsx(AlertDialogCloseButton, __assign({ color: "green.500", boxSize: 4, position: "inherit", ref: cancelRef }, { children: _jsx(Close, {}) }))] })) })), _jsxs(AlertDialogBody, __assign({ px: 5 }, { children: [_jsx(IssueReason, {}), _jsxs(Stack, __assign({ spacing: 3, mt: 3 }, { children: [_jsx(IssueCaution, {}), _jsx(IssueWarning, {})] }))] })), _jsx(AlertDialogFooter, __assign({ paddingInline: 5 }, { children: _jsx(IssueActions, { disclosure: disclosure, isLoading: isLoading }) }))] })) }) }) })) })));
};
